import { TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../../mobile.setup';

const parent = Mobile.pages.endUsers;
const path = 'metrics';
const title = 'PAGE.MOBILE.END_USERS.METRICS.TITLE';

export const MobileEndUsersMetricsTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title);
